import styled, { css } from 'styled-components';

export const DebugPanel = styled.div(
  ({ theme }) => css`
    position: absolute;
    right: ${theme.sz.s4};
    top: ${theme.sz.s32};
    padding: ${theme.sz.s1};
    text-align: end;
    border: ${theme.bo.thinWidth} solid ${theme.co.neutral0};
    border-radius: ${theme.bo.small};
    background-color: ${theme.co.neutral90};

    audio {
      height: ${theme.sz.s7};
      width: ${theme.sz.s54};
    }
  `,
);
